import { IssueTaskCategory, IssueTaskDoc } from '@gooduncles/gu-app-schema';
import { useMemo } from 'react';
import { getIssueTask } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const getIssueTasks = async (issueTaskIds: IssueTaskDoc['_id'][]) => {
  const promises = issueTaskIds.map((id) => getIssueTask(id));
  return Promise.all(promises);
};

const useIssueTasksByIds = (issueTaskIds: IssueTaskDoc['_id'][] | null) => {
  const {
    data,
    isLoading: issueTasksLoading,
    error: issueTasksError,
  } = useSWR(issueTaskIds ? issueTaskIds : null, getIssueTasks, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });
  const issueTasks = useMemo(
    () =>
      data
        ? (data.filter((task) => task !== undefined && task.category !== IssueTaskCategory.INTERNAL) as IssueTaskDoc[])
        : undefined,
    [data]
  );

  return {
    issueTasks,
    issueTasksLoading,
    issueTasksError,
  };
};

export default useIssueTasksByIds;
